import { AfterViewInit, ChangeDetectorRef, Component } from "@angular/core";
import { StateService } from "@uirouter/core";

@Component({
    selector: 'logincallback',
    templateUrl: "./logincallback.view.html",
    styleUrls: ["./logincallback.style.scss"],
    standalone: false
})
export class LogincallbackComponent implements AfterViewInit {

    isActive: boolean = false;
    isFadeOut: boolean = false;

    constructor(
        private $state: StateService,
        private cd: ChangeDetectorRef
    ) {}

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.isActive = true;
            this.cd.markForCheck();
        }, 200);
    }

    backToLogin() {
        this.isActive = false;
        setTimeout(() => this.$state.go('login'), 300);
    }
}
